import { type JSX } from 'react';

import { Icon } from '@videoblocks/design-system';

export const SelectedOverlay = (): JSX.Element => {
    return (
        <div
            data-testid="selected-overlay"
            className="absolute inset-0 flex items-end justify-end bg-black/20 p-4 inset-ring-2 inset-ring-yellow-500 rounded-sm"
        >
            <div className="flex size-6 items-center justify-center rounded-full bg-neutral-dark-100">
                <Icon
                    name="checkCircle"
                    className="[&_path]:fill-yellow-500"
                    width={24}
                    height={24}
                    data-testid="selected-overlay-check-circle-icon"
                />
            </div>
        </div>
    );
};
